module.exports = __webpack_public_path__ + "static/img/分组101.9ce430a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/分组101.png
// module id = 5c7I
// module chunks = 1